interface SitePhotoProps {
  src: string
  alt: string
  aspect?: string
  className?: string
  position?: string
}

export const SitePhoto = ({
  src,
  alt,
  aspect = 'aspect-[4/3]',
  className = '',
  position = 'object-center',
}: SitePhotoProps) => (
  <div className={`relative overflow-hidden rounded-2xl bg-base-100 ${aspect} ${className}`}>
    <img
      src={src}
      alt={alt}
      className={`absolute inset-0 h-full w-full object-cover ${position}`}
      loading="lazy"
    />
  </div>
)
